const GlobalVariable = Object.freeze({
    BASE_APP_URL: 'https://adminstandout.smartranserp.com',
    API_URL: 'https://standoutapi.infuture.ai',
    BASE_API_URL: "https://adminstandoutapi.infuture.ai/api",
})

export default GlobalVariable;

// const BASE_API_URL = 'https://adminstandoutapi.infuture.ai/api' || 'https://adminkinnectivedevapi.smartranserp.com/api' || 'http://localhost:3001/api';

// const STANDOUT_API_URL = 'https://standoutapi.infuture.ai' || 'https://kinnectiveapi.smartranserp.com' || 'http://localhost:3001';

// BASE_APP_URL: 'https://adminkinnective.smartranserp.com' || 'http://localhost:3002' || 'https://adminstandout.smartranserp.com',